import React from "react";
import { Tooltip } from "react-tooltip";

/**
 * "+N" beside one visible label. Hover or focus lists the labels that did not fit.
 */
const CareWatchOverflowCount = ({ count = 0, labels = [], tooltipId }) => {
  const hidden = (Array.isArray(labels) ? labels : [])
    .map((label) => String(label || "").trim())
    .filter(Boolean);
  const extra = hidden.length || Number(count) || 0;

  if (extra < 1 || hidden.length < 1) {
    return null;
  }

  const id =
    tooltipId || `cw-overflow-${hidden.join("-").slice(0, 48)}-${extra}`;
  const tooltipText = hidden.join("\n");

  return (
    <>
      <span
        className="care-watch-detail-count care-watch-detail-count--interactive"
        data-tooltip-id={id}
        data-tooltip-content={tooltipText}
        tabIndex={0}
        aria-label={`${extra} more: ${hidden.join(", ")}`}
      >
        +{extra}
      </span>
      <Tooltip
        id={id}
        place="top"
        variant="dark"
        className="z-[501] !max-w-xs !whitespace-pre-line !text-xs !leading-relaxed"
        positionStrategy="fixed"
      />
    </>
  );
};

export default CareWatchOverflowCount;
